import { Box, Flex } from '@chakra-ui/react';
import NewsArticle from '../components/NewsArticle';
import StudentSpotlight from '../documents/John_Bajor_Student_Spotlight.pdf';
import StudentSpotlightImage from '../images/johnBass.jpg';
import SpeakEasyImage1 from '../images/speakEasyImage1.png';
import SpeakEasyImage2 from '../images/speakEasyImage2.png';
import ZenithFounders from '../images/zenithFounders.png';

const newsArticles = [
    {
        title: "From Imaginary Company to Real Success",
        date: "June 05, 2025",
        subtitle: "In 2021, sophomore computer science majors Darrin Lea, Blake Bollinger, John Bajor and Trevor Baughman wanted to attend CES. The problem? The country’s biggest tech show was only open to business professionals.",
        image: ZenithFounders,
        link: "https://www.lsu.edu/innovation/news/2025/2025.6.5_zenith_software.php"
    },
    {
        title: "LSU Student Spotlight",
        date: "LSU The Mag - Spring 2023 Edition",
        subtitle: "John Bajor makes the most out of every opportunity that comes his way. The LSU junior balances working with his growing tech company, performing with his rock band and studying computer science.",
        image: StudentSpotlightImage,
        link: StudentSpotlight
    },
    {
        title: "Meet the Band: Speak Easy",
        date: "November 25, 2022",
        subtitle: "Every member of the Baton Rouge band Speak Easy has a role on stage and another one behind the scenes. “We like keeping everything in-house,” Drake Dugas said. “It’s fun that way. We get to work together a lot more.”",
        image: SpeakEasyImage2,
        link: "https://lsureveille.com/156565/entertainment/meet-the-band-baton-rouge-group-speak-easy-talks-about-producing-and-performing/"
    },
    {
        title: "An Interview with Speak Easy",
        date: "April 14, 2022",
        subtitle: "A rock band that pulls inspiration from genres across the board, from 70s-style music to bands like Pink Floyd, Speak Easy creates their own sound with five talented members. You can hear this live at Chelsea’s Live on April 14.",
        image: SpeakEasyImage1,
        link: "https://lsureveille.com/155978/entertainment/music/an-interview-with-speak-easy/"
    }
];

export default function News() {
    return (
        <Flex
            id="news"
            flexDirection="column"
            alignItems="center"
            justifyContent="space-between"
            padding="5%"
            paddingLeft="10%"
            paddingRight="10%"
            backgroundColor="black.200"
            minW="100%"
            overflowX={"hidden"}
        >
            <Box
                fontSize="4xl"
                fontFamily="Source Code Pro Variable"
                fontWeight="600"
                width="100%"
                textAlign="center"
                color="white.200"
                marginBottom="5%"
            >
                In the News
            </Box>

            <Flex
                flexDirection={{ base: 'column', md: 'row' }}
                width="100%"
                gap={4}
                alignItems="stretch"
            >
                {newsArticles.map((article, index) => (
                    <NewsArticle
                        key={index}
                        {...article}
                    />
                ))}
            </Flex>
        </Flex>
    );
}
